<template>
  <div class="abnormal-driver-dtl">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>异常{{ getTypeName }}明细</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">创建日期</span>
        <el-date-picker
          v-model="filter.startTime"
          type="date"
          style="width: 140px"
          disabled
          value-format="timestamp"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker v-model="filter.endTime" type="date" style="width: 140px" value-format="timestamp" disabled>
        </el-date-picker>
      </div>

      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">异常类型</span>
        <el-select v-model="abnormalTypeArr" multiple collapse-tags placeholder="请选择" class="multiple-select-ie">
          <el-option v-for="item in abnormalTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-2">
        <el-popover ref="popover1" placement="top-start" width="240" trigger="focus" :content="`搜索${searchType}`">
        </el-popover>
        <span class="demonstration">筛选条件</span>
        <el-input
          v-model.trim="filter.keyword"
          v-popover:popover1
          style="width: 240px"
          :maxlength="ordernumberKeywordLimit"
          :placeholder="`输入${searchType}`"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="demonstration">运输类型</span>
        <el-select v-model="filter.orderType" placeholder="请选择" style="width: 148px">
          <el-option v-for="item in orderTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-4">
        <span class="demonstration">数据类型</span>
        <el-select v-model="filter.timeState" placeholder="请选择" style="width: 148px">
          <el-option v-for="item in timeStateList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-5">
        <span class="item-label">装货地名称</span>
        <el-input
          v-model.trim="filter.loadAddress"
          style="width: 170px"
          :maxlength="addressKeywordLimit"
          placeholder="请输入装货地名称"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-6">
        <span class="item-label">卸货地名称</span>
        <el-input
          v-model.trim="filter.unloadAddress"
          :maxlength="addressKeywordLimit"
          style="width: 170px"
          placeholder="请输入卸货地名称"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-7">
        <el-button type="primary" size="small" @click="search">筛选</el-button>
      </div>
    </div>
    <div class="table-custom-box mt-10" id="auto-8">
      <el-table :data="tableData.data" border>
        <el-table-column prop="orderNumber" label="运单号" width="240">
          <template v-slot="scope">
            {{ scope.row.orderNumber }}
            <span v-if="scope.row.logisticsCompany" class="task-order-tag"
              ><i></i>{{ scope.row.logisticsCompany | filterTaskOrderTag }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="abnormalNum" label="异常次数" width="100">
          <template v-slot="scope">
            <span class="font-blue">{{ scope.row.abnormalNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="abnormalTypeDesc" label="异常类型" width="160"> </el-table-column>
        <el-table-column label="车牌号" width="160">
          <template v-slot="scope">
            {{ scope.row.plateNumber }}
            <span
              v-if="scope.row.plateNumberListType"
              :class="[scope.row.plateNumberListType == 1 ? 'yellow-tag' : 'white-tag']"
              >{{ scope.row.plateNumberListType == 1 ? '黄名单' : '白名单' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="司机" width="160">
          <template v-slot="scope">
            {{ scope.row.driverName }}
            <span
              v-if="scope.row.driverNameListType"
              :class="[scope.row.driverNameListType == 1 ? 'yellow-tag' : 'white-tag']"
              >{{ scope.row.driverNameListType == 1 ? '黄名单' : '白名单' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" width="140"> </el-table-column>
        <el-table-column prop="loadAddress" label="装货地址" width="100"> </el-table-column>
        <el-table-column prop="unloadAddress" label="卸货地址" width="100"> </el-table-column>
        <el-table-column prop="travelLengthTime" label="运输时长" width="120"> </el-table-column>
        <el-table-column prop="signLoadTime" label="装货签到时间" width="140"> </el-table-column>
        <el-table-column prop="signUploadTime" label="卸货签到时间" width="140"></el-table-column>
        <el-table-column prop="driverCaptainName" label="车队长" width="120"> </el-table-column>
        <el-table-column prop="driverCaptainPhone" label="车队长电话" width="120"> </el-table-column>
        <el-table-column prop="agentName" label="经纪人" width="120"> </el-table-column>
        <el-table-column prop="agentPhone" label="经纪人电话" width="120"> </el-table-column>
        <el-table-column label="操作" width="240" fixed="right">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)" class="font-blue">查看轨迹</el-button>
            <el-dropdown
              trigger="click"
              class="ml-6"
              v-if="scope.row.driverJoinYellow == false || scope.row.vehicleJoinYellow == false"
            >
              <el-button type="text"> 加入黄名单<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.vehicleJoinYellow == false"
                  @click.native="handleAddYellowList(scope.row, 'plate')"
                  >车辆加入黄名单</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.driverJoinYellow == false"
                  @click.native="handleAddYellowList(scope.row, 'driver')"
                  >司机加入黄名单</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="scope.row.onTheWayCheck" type="text" size="small" @click="handleSendMsg(scope.row)"
              >短信提醒</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import { WUYI, vali } from '@/api/common';
export default {
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      companyPhone: WUYI.currentData.company.companyphone,
      companyCode: WUYI.currentData.company.companycode,
      abnormalTypeArr: [],
      filter: {
        startTime: 0,
        endTime: 0,
        keyword: '',
        multiAbnormalType: '',
        orderType: 0,
        loadAddress: '',
        unloadAddress: '',
        timeState: 0
      },
      abnormalTypeList: [
        { label: '无定位', value: 1, name: 'location' },
        { label: '中途停车', value: 2, name: 'park' },
        { label: '运输超时', value: 4, name: 'timeout' },
        { label: 'APP离线', value: 8, name: 'offLine' },
        { label: '黑名单地点停车', value: 32, name: 'blacklistStop' },
        { label: '夜间停车', value: 512, name: 'nightStop' },
        { label: '中交全程无定位', value: 128, name: 'noLocationWhole' },
        { label: '超速', value: 1024, name: 'overspeed' },
        { label: '超载', value: 2048, name: 'overload' },
        { label: '疲劳驾驶', value: 4096, name: 'drowsy' },
        { label: '风险车辆', value: 8192, name: 'riskcar' },
        { label: '风险司机', value: 16384, name: 'riskdriver' }
      ],
      tableData: {
        total: 0,
        data: []
      },
      orderTypeList: [
        { label: '全部', value: 0 },
        { label: '普通运单', value: 1 },
        { label: '任务单', value: 2 }
      ],
      timeStateList: [
        { label: '历史', value: 0 },
        { label: '实时', value: 1 }
      ]
    };
  },
  computed: {
    searchType() {
      if (this.$route.query.type == 'captain') {
        return `运单号、车牌号、司机姓名、司机手机号、经纪人、经纪人号码`;
      } else if (this.$route.query.type == 'agent') {
        return `运单号、车牌号、司机姓名、司机手机号、车队长、车队长号码`;
      } else {
        return `运单号、车牌号、车队长、车队长号码、经纪人、经纪人号码`;
      }
    },
    getTypeName() {
      if (this.$route.query.type == 'captain') {
        return '车队长';
      } else if (this.$route.query.type == 'agent') {
        return `经纪人`;
      } else {
        return `司机`;
      }
    }
  },
  watch: {
    abnormalTypeArr(arr) {
      this.filter.multiAbnormalType = arr.join(',');
    }
  },
  created() {
    const type = this.$route.query.type;
    const abnormalType = this.$route.query.abnormalType;
    const sDate = this.$route.query.sDate;
    const eDate = this.$route.query.eDate;
    const captainCode = this.$route.query.captainCode;
    const agentCode = this.$route.query.agentCode;
    const driverCode = this.$route.query.driverCode;
    if (!sDate || !eDate) {
      this.$router.push({ name: 'DrivingControl' });
      return;
    }
    if (type && type != 'captain' && type != 'agent' && abnormalType) {
      // 多个异常类型以&隔开
      let abnormalTypeName = abnormalType.split('&');
      this.abnormalTypeArr = abnormalTypeName.map(el => this.getAbnormalType(el));
      this.filter.multiAbnormalType = this.abnormalTypeArr.join(',');
    }
    this.filter.startTime = +sDate;
    this.filter.endTime = +eDate;
    if (captainCode) {
      this.filter.captainCode = captainCode;
    }
    if (agentCode) {
      this.filter.agentCode = agentCode;
    }
    if (driverCode) {
      this.filter.driverCode = driverCode;
    }
    this.featchData();
  },
  methods: {
    getAbnormalType(type) {
      return this.abnormalTypeList.filter(item => item.name == type)[0].value;
    },
    search() {
      this.currentPage = 1;
      this.featchData();
    },
    featchData() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        companyCode: this.companyCode,
        ...this.filter
      };
      axiosNew.post(api.geopointOrders, options).then(res => {
        this.tableData = res.data;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.featchData();
    },
    handleClick(item) {
      //运单轨迹
      window.open(`./logistics.html#/orderDtlMap/${item.orderNumber}`);
    },
    handleAddYellowList(item, type) {
      let msg = type === 'plate' ? '车牌' : '司机';
      this.$confirm(`确认添加${msg}到黄名单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 加入黄名单
          let postData =
            type == 'driver'
              ? { keyword: item.driverCode, keywordType: 1 }
              : { keyword: item.plateNumber, keywordType: 2 };
          postData.companyCode = this.companyCode;
          postData.companyListType = 2;
          axiosNew.post(api.billmanagerAdd, postData).then(res => {
            this.search();
          });
        })
        .catch(() => {});
    },
    handleSendMsg(item) {
      const options = {
        orderNumber: item.orderNumber,
        companyPhone: this.companyPhone
      };
      axiosNew.post(api.onTheWayAbnormalListSendSMS, options).then(res => {});
    }
  }
};
</script>
